import { api } from '../../../services/api/client';

export interface PaymentConfig {
  mode: string;
  env: string;
  merchant_code: string;
  api_key_set: boolean;
  api_key_preview: string;
  signature_mode: string;
  public_base_url: string;
  default_payment_method: string;
  expiry_period: number;
  callback_url: string;
  return_url: string;
}

export interface PaymentConfigUpdate {
  mode?: string;
  env?: string;
  merchant_code?: string;
  api_key?: string;
  signature_mode?: string;
  public_base_url?: string;
  default_payment_method?: string;
  expiry_period?: number;
}

export interface TestResult {
  ok: boolean;
  response_code?: string;
  message: string;
  methods: { paymentMethod: string; paymentName: string; totalFee: string }[];
}

export async function adminGetPaymentConfig(): Promise<PaymentConfig> {
  const { data } = await api.get<PaymentConfig>('/admin/payment-config');
  return data;
}
export async function adminUpdatePaymentConfig(payload: PaymentConfigUpdate): Promise<PaymentConfig> {
  const { data } = await api.put<PaymentConfig>('/admin/payment-config', payload);
  return data;
}
export async function adminTestPaymentConnection(): Promise<TestResult> {
  const { data } = await api.post<TestResult>('/admin/payment-config/test');
  return data;
}
